
  import { Vue, Component, Emit, Prop } from "vue-property-decorator";
  import { IAdsModel } from "@/models";
  import { Utils } from "@/helper";
  import dayjs from "dayjs";

  @Component({
    name: "PostListvalueAdmin"
  })
  export default class PostListvalueAdmin extends Vue {
    @Prop() value!: IAdsModel;
    @Prop({ default: "" }) searchText!: string;
    @Emit("delete")
    onDeleteHandler(ad: IAdsModel) {
      // empty function
    }
    @Emit("save")
    onSaveHandler(ad: IAdsModel) {
      // empty function
    }
    @Emit("blacklist")
    onBlacklistHandler(ad: IAdsModel) {
      // empty function
    }

    get highlight(): string {
      if (this.searchText.trim() === "") {
        return this.value.contents;
      }
      return this.value.contents.replace(
        new RegExp(this.searchText, "gi"),
        match => {
          return "<span class='highlightText'>" + match + "</span>";
        }
      );
    }
    get publicPath() {
      return `${window.location.origin}${process.env.BASE_URL}`;
    }

    onDelete() {
      this.onDeleteHandler(this.value);
    }
    onSave() {
      if (this.value.action === 0) {
        this.$modal.show("Choose an Action for Selected Ad", "error");
      } else {
        this.onSaveHandler(this.value);
      }
    }
    update(key: string, value: object) {
      const updated = { ...this.value, [key]: value };
      this.$emit("input", updated);
    }
    getAdImage(id: number) {
      if (process.env.NODE_ENV === "development") {
        return `${process.env.VUE_APP_IMAGE_HANDLER}?docid=${id}`;
      }
      return `${window.location.origin}/${process.env.VUE_APP_IMAGE_HANDLER}?docid=${id}`;
    }
    getPostingDate(date: Date) {
      return dayjs(date).format("MM/DD/YYYY hh:mm A");
    }

    parentCategory(parentCategory: IAdsModel) {
      return (
        (parentCategory === null ? "Category" : `${parentCategory.category}`) +
        " - "
      );
    }
    call(phoneNumber: string) {
      const phone = Utils.PhoneNumberFormated(phoneNumber);
      window.open(`tel:${phone}`);
    }
    phoneNumberFormated(phone: string): string {
      return Utils.PhoneNumberFormated(phone);
    }
    async addToBlacklist() {
      const value = this.value.blackListed === null ? 1 : null;
      const updated = { ...this.value, ["blackListed"]: value };
      this.$emit("input", updated);
      this.$nextTick(() => {
        this.onBlacklistHandler(this.value);
      });
    }
  }
